module.exports = __webpack_public_path__ + "img/Realisme_Naturalismen_Jaeger.c4b5c28c.jpg";